import React from 'react'
import {IconProps} from '../../types/IconProps'
import getColorPalette from 'utils/getColorPalette'

const IconAddPayment = ({height, width, color}: IconProps) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 12.5039V8.00391C21 6.89934 20.1046 6.00391 19 6.00391H5C3.89543 6.00391 3 6.89934 3 8.00391V17.0039C3 18.1085 3.89543 19.0039 5 19.0039H13'
        stroke={color || getColorPalette().secondaryColor}
        strokeWidth='1.54286'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M18.4998 15.0039V17.5039M18.4998 17.5039V20.0039M18.4998 17.5039H15.9998M18.4998 17.5039H20.9998'
        stroke={color || getColorPalette().secondaryColor}
        strokeWidth='1.54286'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3 10.0039H20.5'
        stroke={color || getColorPalette().secondaryColor}
        strokeWidth='1.54286'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.99976 15.0039H8.99976'
        stroke={color || getColorPalette().secondaryColor}
        strokeWidth='1.54286'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default IconAddPayment
